import React from 'react';
import Chip from '@mui/material/Chip';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import BlockIcon from '@mui/icons-material/Block';
import useTranslation from '../../customHooks/translations';

// Shown to the author (and admins) while a public post waits for / failed admin approval
const ApprovalStatusBadge = ({ approvalStatus, sx }) => {
  const translation = useTranslation();

  if (approvalStatus !== 'pending' && approvalStatus !== 'rejected') {
    return null;
  }

  const isPending = approvalStatus === 'pending';
  return (
    <Chip
      size="small"
      icon={isPending ? <HourglassTopIcon /> : <BlockIcon />}
      label={isPending ? translation.moderation.pending : translation.moderation.rejected}
      color={isPending ? 'warning' : 'error'}
      variant="outlined"
      sx={{ fontWeight: 600, ...sx }}
    />
  );
};

export default ApprovalStatusBadge;
